import React, { useContext } from "react";

import NavigationMenuContext from "../NavigationMenuContext";

import { LangNav } from "../Lang/lang";
import { Button } from "../../Button";

import { useIsDesktop } from "../../../lib/hooks/mediaQueries";
import GeneralPageContext from "../../../templates/GeneralPageContext";
import { SearchNav } from "../Search/search";
import { UserNav } from "../User/user";
import t from "../../../lib/translate";
import * as styles from "./iconNavigation.module.less";

export default function IconNavigation({ className }) {
    const isMobile = useIsDesktop();

    const {
        locale,
        layout: { slimTopBar }
    } = useContext(GeneralPageContext);

    const {
        navigationReducer: {
            navState: { navigationOpen },
            dispatch
        }
    } = useContext(NavigationMenuContext);

    return (
        <div className={className}>
            {!isMobile && <UserNav className={styles.loginButton} />}
            <Button
                className={styles.menuButton}
                type="secondary"
                icon={navigationOpen ? "close" : "menu"}
                aria-label={
                    navigationOpen
                        ? t`navigation.button.close`
                        : t`navigation.button.menu`
                }
                onClick={() =>
                    dispatch({
                        type: "toggleMobileNav",
                        navOpen: !navigationOpen
                    })
                }
            />
            {!slimTopBar && (!isMobile || !navigationOpen) && (
                <div>
                    <LangNav active={locale} />
                    <SearchNav />
                </div>
            )}
        </div>
    );
}
